import { vertigo } from "assets/jsonInfo/vertigo";
import { vivencias } from "assets/jsonInfo/vivencias";
import { juntoHuesos } from "assets/jsonInfo/juntoHuesos";
import { tintaAyer } from "assets/jsonInfo/tintaAyer";

export const postsByCategory = {
  "voy-junto-a-mis-huesos": juntoHuesos,
  "con-tinta-de-ayer": tintaAyer,
  "corazon-de-vertigo-y-remanzo": vertigo,
  vivencias: vivencias,
};
